import {  Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import RoundButton from "../../../../Common/RoundButton";
import cersaiLogo from "../../../../utils/assests/dummy-img.png";
import ErrorMessage from "../../../../Common/ErrorMessage";

const PersonalDetailsForm = (props: any) => {
  const { handleAccept, ckycDetails,ckycConfirmError } = props;
  return (
    <>
      <Box className="personalInfo">
        <Box sx={{ mb: 3.5 }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h3" className="fs-18 fw-600 text-color-one">
              Verify your details
            </Typography>
          </Box>
          <Typography className="fs-12 fw-500 text-color-one">
            The below details have been retrieved form Central KYC registry.
            Your unique ID is {ckycDetails?.results?.ckyc_number || ''}
          </Typography>
        </Box>
        <div className="border-line-1" />
        <Box className="verifypInfo" sx={{ mt: 2.6 }}>
          <Typography className="fs-12 fw-500 text-color-one">
            Full Name
          </Typography>
          <Typography variant="h5">{ckycDetails?.results?.full_name || ''}</Typography>
          <Typography>Date of birth</Typography>
          <Typography variant="h5">{ckycDetails?.results?.dob || ''}</Typography>
          <Typography>Address</Typography>
          <Typography variant="h5">{ckycDetails?.results?.address || ''}</Typography>
          <div className="border-line-1" />
        </Box>
        <div className="byPos">
          <Typography className="fs-10 text-dark">
            By proceeding, you consent Liquiloans to use your KYC records from
            central KYC registry
          </Typography>
        </div>
        <div style={{ marginTop: "10px" }} />
        {
          ckycConfirmError?.errors?.detail && <ErrorMessage text={ckycConfirmError?.errors?.detail} />
        }
        <div style={{ marginTop: "20px" }}>
          <RoundButton onClick={handleAccept} title="Accept & Proceed" />
        </div>
        <div className="cersai">
          <Typography className="fs-12 text-color-one">
            details fetched via CERSAI
          </Typography>
          <img src={cersaiLogo} alt="logo" />
        </div>
      </Box>
    </>
  );
};

export default PersonalDetailsForm;